export default "__VITE_ASSET__Ch1Q9BBC__"